import { useEffect, useState } from "react";
import "../layout/axe-survey.css"

interface Question {
  question: string;
  answers: string[];
}

const questions: Question[] = [
  {
    question: "GÜNÜN HANGİ DİLİMİ SENİ YANSITIR?",
    answers: ["SABAH", "GECE", "GÜN ORTASI"],
  },
  {
    question: "STİLİNİ NASIL TANIMLARSIN?",
    answers: ["RENKLİ, ENERJİK", "GİZEMLİ, KLAS", "SADE, MİNİMALİST"],
  },
  {
    question: "İNSANLAR SENİN MOOD’UNU NASIL TANIMLAR?",
    answers: ["NEŞELİ, SOSYAL", "DERİN, SOFİSTİKE", "SAKİN, İÇE DÖNÜK"],
  },
  {
    question: "SANA GÖRE ÇEKİCİLİĞİN TANIMI NEDİR?",
    answers: [
      "GİRDİĞİN ORTAMIN ENERJİSİNİ YÜKSELTMEK",
      "MERAK UYANDIRMAK",
      "MİNİMALİST ETKİ",
    ],
  },
  {
    question: "İŞTE BENİM TATİLİM DEDİĞİN TATİL HANGİSİ?",
    answers: [
      "EĞLENCE DOLU BEACH PARTY’LER",
      "GİZEM DOLU KEŞİFLER",
      "DOĞAYLA İÇ İÇE SAKİN BİR TATİL",
    ],
  },
  {
    question: "YORUCU BİR GÜNÜN SONUNDA NASIL RAHATLARSIN?",
    answers: [
      "ARKADAŞLARLA TAM GAZ EĞLENCE",
      "MÜZİK DİNLEYİP KENDİ İÇİNE DÖNMEK",
      "TEMİZ HAVADA YÜRÜYÜŞ",
    ],
  },
  {
    question: "BİR GÜNLÜĞÜNE INFLUENCER OLSAN NE PAYLAŞIRDIN?",
    answers: [
      "EĞLENCE VE MİZAH İÇERİKLERİ",
      "STİL VE YAŞAM TARZI İÇERİKLERİ",
      "GEZİ, SEYAHAT, KEŞİF İÇERİKLERİ",
    ],
  },
  {
    question: "ŞU AN HANGİSİNİ YEMEYİ/İÇMEYİ TERCİH EDERDİN?",
    answers: ["VİŞNELİ TURTA", "VANİLYALI DONDURMA", "MEYVELİ SOĞUK ÇAY"],
  },
];

export default function AxeWatsons() {
  const [step, setStep] = useState(0);
  const [score, setScore] = useState<number[]>([]);
  const [fade, setFade] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);

  useEffect(() => {
    document.fonts.load('1rem "Rifton"').then(() => {
      document.body.classList.add("fonts-loaded");
    });
  }, []);

  const handleAnswer = (index: number) => {
    setSelectedAnswer(index);
    setTimeout(() => {
      const updated = [...score, index];
      setScore(updated);
      setFade(true);
      setTimeout(() => {
        setFade(false);
        setSelectedAnswer(null); // reset for next question
        if (step <= questions.length) setStep(step + 1);
      }, 500);
    }, 1000);
  };

  const getResultImage = () => {
    const count = [0, 0, 0];
    score.forEach((s) => count[s]++);
    const maxIndex = count.indexOf(Math.max(...count));
    return `${process.env.PUBLIC_URL}/assets/survey/product-suggestion-${maxIndex + 1}.jpg`;
  };

  useEffect(() => {
    const handleTouch = () => {
      if (step === 0) setStep(1);
    };
    document.addEventListener("click", handleTouch);
    return () => document.removeEventListener("click", handleTouch);
  }, [step]);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (step === 0) {
    return <img src={`${process.env.PUBLIC_URL}/assets/survey/start-screen.jpg`} className="axe-full" />;
  }

  if (step > questions.length) {
    return (
      <img
        src={getResultImage()}
        className="axe-full axe-clickable"
        onClick={handleRefresh}
      />
    );
  }

  const current = questions[step - 1];
  return (
    <div className="axe-survey-wrapper">
      <div className={`axe-question ${fade ? "fade-out" : "fade-in"}`}>
        <h2>{current.question}</h2>
        <ul className="axe-answers">
          {current.answers.map((a, i) => (
            <li className={`axe-answer ${selectedAnswer === i ? "selected" : ""}`} key={i} onClick={() => handleAnswer(i)}>
              {String.fromCharCode(65 + i)} - {a}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}